import React, { useEffect, useState } from 'react';
import styles from './WordSearch.module.less';
import { CloseOutlined } from '@ant-design/icons';
interface WordSearchProps {
  onSearch: (query: string) => void;
  initialQuery?: string;
}

const WordSearch: React.FC<WordSearchProps> = ({ onSearch, initialQuery = '' }) => {
  const [query, setQuery] = useState(initialQuery);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const handleSearch = () => {
    if (query) {
      onSearch(query);
    }
  };

  // 添加回车事件处理
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && query) {
      onSearch(query);
    }
  };

  useEffect(() => {
    setQuery(initialQuery || '');
  }, [initialQuery]);

  return (
    <div className={styles.searchSection}>
      <div className={styles.searchInputBlock}>
        <input
          type="text"
          value={query}
          onChange={handleInputChange}
          onKeyDown={handleKeyPress} // 添加回车事件
          placeholder="输入单词"
          className={styles.searchInput}
        />
        {query && (
          <div className={styles.clearIcon} onClick={() => setQuery('')}>
            <CloseOutlined />
          </div>
        )}
      </div>
      <button onClick={handleSearch} className={styles.searchButton}>
        查词
      </button>
    </div>
  );
};

export default WordSearch;
